import {PermissionModel, UserComponentModel} from './models'
import {Store} from '../../app/redux/Store'
import {setCurrentUser} from '../../app/redux/currentUser/CurrentUserAction'
import * as genericServices from './genericServices'
import { useEffect, useState } from 'react'


export const HasPermission = (
  component: keyof UserComponentModel,
  permission: keyof PermissionModel
) => {
  const store = Store.getState()
  const currentUser = store.globalStates.currentUser
  let userComponents = currentUser?.components
  if (userComponents) {
    return currentUser?.components[component]?.permission[permission]
  }
  return false
}

export const ConvertDate = (date: number) => {
  const dateString = new Date(date * 1000)
  return dateString.toLocaleString('en-us', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  })
}

export const ConvertFormDate = (date: number, format: 'timestamp' | undefined) => {
  let convertedDate
  if (format === 'timestamp') {
    convertedDate = new Date(date * 1000)
  } else {
    convertedDate = new Date(date)
  }
  return convertedDate.toISOString().split('T')[0]
}

export const UpdateBusinessDetail = async (dispatch:any) => {
  console.log("Update business detail Called")
  const store = Store.getState()
  const currentUser = store.globalStates.currentUser
  const response = await genericServices.get('business/get_current_business_detail')
  if (response.status === 200) {
    dispatch(setCurrentUser({...currentUser, ...response.data}))
  }
}

export const handleSSOLogin = async (module: any) => {
  try {
    const response = await genericServices.get("users/detail");

    if (response.status === 200 && response.data.app_keys) {
      const { public_key, private_key } = response.data.app_keys;

      const childWindow = window.open(`${module.url}`, "_blank");

      const sendKeys = () => {
        if (childWindow) {
          childWindow.postMessage(
            {
              type: "SSO_LOGIN",
              publicKey: public_key,
              privateKey: private_key,
              source: "sso_redirect",
            },
            module.url 
          );
        }
      };

      setTimeout(sendKeys, 1500);
      return true;
    } 
  } catch (error) {
    console.error("SSO login failed", error);
    throw error;
  }
  return false;
};

/**
 * A reusable hook for implementing debounced search functionality
 * @param initialValue - Initial search text value
 * @param delay - Debounce delay in milliseconds
 * @param fetchCallback - Function to call when search text changes (after debounce)
 * @returns Object containing search text, setter function, and loading state
 */
export const useSearchWithDebounce = (
  initialValue: string = '',
  delay: number = 500,
  fetchCallback: (searchText: string) => Promise<void>
) => {
  const [searchText, setSearchText] = useState<string>(initialValue)
  const [debouncedSearchText, setDebouncedSearchText] = useState<string>(initialValue)
  const [loading, setLoading] = useState<boolean>(false)

  // Update debounced value after delay
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [searchText, delay])

  // Call fetch callback whenever debounced search text changes
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await fetchCallback(debouncedSearchText)
      setLoading(false)
    }

    fetchData()
  }, [debouncedSearchText, fetchCallback])

  // Trigger initial fetch on mount so lists load without typing
  useEffect(() => {
    const initialFetch = async () => {
      setLoading(true)
      await fetchCallback(initialValue)
      setLoading(false)
    }
    initialFetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    searchText,
    setSearchText,
    loading,
  }
}
